import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

type TNotificationTypes = {
  type: 'API_ERROR';
  toastOptions: NonNullable<Parameters<ToastController['create']>[0]>;
};

@Injectable({
  providedIn: 'root',
})
export class ToastNotificationService {
  constructor(private toastController: ToastController, private translateService: TranslateService) {}

  async showNofification(options: TNotificationTypes['toastOptions']) {
    const toast = await this.toastController.create({
      position: 'bottom',
      color: 'warning',
      ...options,
      buttons: [
        ...(options.buttons ? options.buttons : []),
        {
          text: this.translateService.instant('common_components.cancel'),
          role: 'cancel',
        },
      ],
    });
    toast.present();
  }
}
